import { render, staticRenderFns } from "./DataTickerWidgetWrapper.vue?vue&type=template&id=c80dfb2e"
import script from "./DataTickerWidgetWrapper.vue?vue&type=script&lang=js"
export * from "./DataTickerWidgetWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports